import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import cn from 'clsx';
import { useEffectAfterMount } from '@crehana/react-hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RewardsTabManager = function RewardsTabManager(_ref) {
  var _ref$tabs = _ref.tabs,
    tabs = _ref$tabs === void 0 ? [] : _ref$tabs,
    selectedTabIndexProp = _ref.selectedTabIndex,
    className = _ref.className,
    style = _ref.style;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTabIndex = _useState2[0],
    setSelectedTabIndex = _useState2[1];
  var onSelectTab = useCallback(function (newIndex) {
    return function () {
      return setSelectedTabIndex(newIndex);
    };
  }, []);
  var renderContent = useCallback(function () {
    var currentTab = tabs[selectedTabIndex];
    if (!currentTab) {
      return;
    }
    var props = currentTab.props,
      Component = currentTab.content;
    return /*#__PURE__*/_jsx(Component, _objectSpread({}, props));
  }, [selectedTabIndex, tabs]);
  useEffect(function () {
    if (selectedTabIndex === -1 && tabs.length) {
      var defaultSelectedTabIndex = tabs.findIndex(function (tab) {
        return tab.defaultSelected;
      });
      if (defaultSelectedTabIndex >= 0) {
        setSelectedTabIndex(defaultSelectedTabIndex);
      }
    }
  }, [selectedTabIndex, tabs, tabs.length]);
  useEffectAfterMount(function () {
    if (selectedTabIndexProp !== undefined) {
      setSelectedTabIndex(selectedTabIndexProp);
    }
  }, [selectedTabIndexProp]);
  return /*#__PURE__*/_jsxs("section", {
    className: cn('tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700 dark:tw-text-primary-light-100 tw-shadow-01 tw-rounded-1.2 tw-pt-1',
    // Size
    'tw-h-full', className),
    style: style,
    children: [/*#__PURE__*/_jsx("nav", {
      className: "tw-list-none tw-flex tw-border-b tw-border-solid tw-border-b-neutral-light-400 dark:tw-border-b-neutral-dark-600",
      children: tabs.map(function (tab, index) {
        var isSelectedTab = index === selectedTabIndex;
        var isFirstTab = index === 0;
        var key = index + tab.label;
        return /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: onSelectTab(index),
          "data-testid": tab.props['data-testid'],
          className: cn('tw-px-1.6 tw-py-1 tw-text-center tw-text-1.4 tw-font-semibold tw-transition-colors',
          // Common border
          'tw-border-b tw-border-solid', isFirstTab && 'tw-ml-2', isSelectedTab ? 'tw-text-primary-light-500 tw-border-b-primary-light-500 dark:tw-text-secondary-dark-500 dark:tw-border-b-secondary-dark-500' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500 tw-border-b-transparent'),
          children: tab.label
        }, key);
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "tw-p-2 tw-h-full",
      children: renderContent()
    })]
  });
};
export default RewardsTabManager;